import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
export const useOrganStore = defineStore('organ', {
  state: () => ({
    depts: [],
    roles: [],
    users: []
  }),
  getters: {
    getUserById: state => {
      return userId => state.users.find(user => user.id === userId) || {
        id: userId,
        name: ''
      };
    },
    getDeptById: state => {
      return deptId => state.depts.find(dept => dept.id === deptId) || {
        id: deptId,
        name: ''
      };
    },
    getRoleById: state => {
      return roleId => state.roles.find(role => role.id === roleId) || {
        id: roleId,
        name: ''
      };
    },
    getById: state => {
      return id => {
        let item = null;
        item = state.depts.find(dept => dept.id === id);
        if (item == null) item = state.roles.find(role => role.id === id);
        if (item == null) item = state.users.find(user => user.id === id);
        return item || {
          id: id,
          name: '未知'
        };
      };
    }
  },
  actions: {
    setDepts(depts) {
      this.depts = [];
      depts = depts || [];
      depts.forEach(dept => {
        if (dept.ParentNo != 0) {
          this.depts.push({
            id: dept.No,
            name: dept.Name,
            pid: dept.ParentNo
          });
        } else {
          this.depts.push({
            id: dept.No,
            name: dept.Name
          });
        }
      });
    },
    setRoles(roles) {
      this.roles = [];
      roles = roles || [];
      roles.forEach(role => this.roles.push({
        id: role.No,
        name: role.Name
      }));
    },
    setUsers(users) {
      this.users = [];
      users = users || [];
      users.forEach(user => this.users.push({
        id: user.No,
        name: user.Name
      }));
    },
    getDepts() {
      return JSON.parse(JSON.stringify(this.depts));
    },
    getRoles() {
      return JSON.parse(JSON.stringify(this.roles));
    },
    getUsers() {
      return JSON.parse(JSON.stringify(this.users));
    }
  }
});